import { FC } from 'react';
import { KontentinoLogo } from '@kontentino/ui';
import clsx from 'clsx';
import Link from 'components/shared/Link';
import routes from 'constants/routes';

type Props = {
  className?: string;
};

const Logo: FC<Props> = ({ className, ...props }) => {
  return (
    <div
      className={clsx(
        'tw-mx-auto tw-flex tw-h-8 tw-w-8 tw-flex-shrink-0 tw-items-center tw-justify-center tw-overflow-hidden',
        className,
      )}
      {...props}
    >
      <Link
        to={routes.DASHBOARD}
        className="tw-flex tw-overflow-hidden"
        isRouterLink
      >
        <KontentinoLogo
          variant="dark"
          className="tw-object-center"
          width={18}
          height={18}
        />
      </Link>
    </div>
  );
};

export default Logo;
